import {Component, Input} from '@angular/core';
import {MpAllergenXBVO, MpDesignationXBVO} from "../../model/xbvo.model";
import {BaseComponent} from "../../base/base.component";

/**
 * App-Component
 */
@Component({
    selector: '<allergens>',
    template: `
        <div class="EmptyBox1 GrayBack"></div>
        <div class="SoftGrayBack" style="padding: 2px 0 4px 4px;">{{v('allergens')}}</div>
        <div class=" d-flex" *ngFor="let pItem of modelRows">
            <div class="FontBold" style="width: 16px;">{{pItem.nr}}</div>
            <div> {{pItem.designation}}</div>
        </div>
        <div class="EmptyBox10"></div>

    `
})
export class AllergensComponent extends BaseComponent {

    @Input()
    modelRows: MpDesignationXBVO[];

}
